export default "__VITE_ASSET__lEfpX$lQ__"